import React from 'react';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import withStyles from '@mui/styles/withStyles';
import Typography from '@mui/material/Typography';

const styles = theme => ({
  textfield: {
    width: '100%',
  },
});

const Textarea = ({classes, handler, question, value = null}) => (
  <Grid item xs={12}>
    <Typography variant="body2" gutterBottom>
      {question.text}
    </Typography>
    <TextField
      value={value}
      onChange={handler}
      variant="outlined"
      multiline
      className={classes.textfield}
      color="secondary"
    />
    <br />
    <br />
  </Grid>
);

export default withStyles(styles)(Textarea);
